import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { CalendarCell, CalendarCellTrigger, CalendarGrid, CalendarGridBody, CalendarGridHead, CalendarGridRow, CalendarHeadCell, CalendarHeader, CalendarHeading, CalendarNext, CalendarPrev, CalendarRoot, useForwardPropsEmits, } from 'reka-ui';
import { CalendarDate } from '@internationalized/date';
import { ChevronLeft, ChevronRight, ChevronDown } from 'lucide-vue-next';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Calendar',
    props: {
        defaultValue: { type: Object, required: false },
        defaultPlaceholder: { type: Object, required: false },
        placeholder: { type: Object, required: false },
        pagedNavigation: { type: Boolean, required: false },
        preventDeselect: { type: Boolean, required: false },
        weekStartsOn: { type: Number, required: false },
        weekdayFormat: { type: String, required: false },
        calendarLabel: { type: String, required: false },
        fixedWeeks: { type: Boolean, required: false },
        maxValue: { type: Object, required: false },
        minValue: { type: Object, required: false },
        locale: { type: String, required: false },
        numberOfMonths: { type: Number, required: false },
        disabled: { type: Boolean, required: false },
        readonly: { type: Boolean, required: false },
        initialFocus: { type: Boolean, required: false },
        isDateDisabled: { type: Function, required: false },
        isDateUnavailable: { type: Function, required: false },
        dir: { type: String, required: false },
        nextPage: { type: Function, required: false },
        prevPage: { type: Function, required: false },
        modelValue: { type: [Object, Array, null], required: false },
        multiple: { type: Boolean, required: false },
        disableDaysOutsideCurrentView: { type: Boolean, required: false },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        showMonthYearDropdowns: { type: Boolean, required: false },
        variant: { type: String, required: false }
    },
    emits: ["update:modelValue", "update:placeholder"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emits = __emit;
        const forwarded = useForwardPropsEmits(props, emits);
        const isCompact = computed(() => props.variant === 'compact');
        const weekdayFormat = computed(() => isCompact.value ? 'short' : props.weekdayFormat);
        const navigationBorderClass = computed(() => !props.showMonthYearDropdowns && !isCompact.value && 'border border-input shadow-sm');
        const monthNames = computed(() => Array.from(Array(12).keys()).map(monthIndex => new Intl.DateTimeFormat(props.locale ?? 'default', { month: 'short' }).format(new Date(2000, monthIndex, 1))));
        const yearRange = computed(() => {
            const current = new Date().getFullYear();
            return Array.from(Array(200).keys()).map(yearOffset => current - 100 + yearOffset);
        });
        function onMonthChange(grid, e) {
            const month = parseInt(e.target.value);
            const year = grid[0]?.value?.year ?? new Date().getFullYear();
            emits('update:placeholder', new CalendarDate(year, month, 1));
        }
        function onYearChange(grid, e) {
            const year = parseInt(e.target.value);
            const month = grid[0]?.value?.month ?? 1;
            emits('update:placeholder', new CalendarDate(year, month, 1));
        }
        const __returned__ = { props, emits, forwarded, isCompact, weekdayFormat, navigationBorderClass, monthNames, yearRange, onMonthChange, onYearChange, get CalendarCell() { return CalendarCell; }, get CalendarCellTrigger() { return CalendarCellTrigger; }, get CalendarGrid() { return CalendarGrid; }, get CalendarGridBody() { return CalendarGridBody; }, get CalendarGridHead() { return CalendarGridHead; }, get CalendarGridRow() { return CalendarGridRow; }, get CalendarHeadCell() { return CalendarHeadCell; }, get CalendarHeader() { return CalendarHeader; }, get CalendarHeading() { return CalendarHeading; }, get CalendarNext() { return CalendarNext; }, get CalendarPrev() { return CalendarPrev; }, get CalendarRoot() { return CalendarRoot; }, get ChevronLeft() { return ChevronLeft; }, get ChevronRight() { return ChevronRight; }, get ChevronDown() { return ChevronDown; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
